var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLogoutMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#25262F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8903 35H48.8849C41.7739 35 36 40.4765 36 47.2211V73.046C36 79.7906 41.7739 85.2671 48.8849 85.2671H59.8903C61.6448 85.2671 63.0686 83.9166 63.0686 82.2525C63.0686 80.5885 61.6448 79.2379 59.8903 79.2379H48.8849C45.2828 79.2379 42.3566 76.4625 42.3566 73.046V47.2211C42.3566 43.8046 45.2828 41.0292 48.8849 41.0292H59.8903C61.6448 41.0292 63.0686 39.6786 63.0686 38.0146C63.0686 36.3505 61.6448 35 59.8903 35V35Z",
    fill: "#E7E7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.9043 57.118H56.1375C54.3831 57.118 52.9592 58.4685 52.9592 60.1326C52.9592 61.7966 54.3831 63.1471 56.1375 63.1471H73.9043L69.0076 67.7916C67.7681 68.9673 67.7681 70.8785 69.0076 72.0542C70.2471 73.2299 72.2622 73.2299 73.5017 72.0542L83.8249 62.2649C85.0644 61.0872 85.0644 59.178 83.8249 58.0003L73.5017 48.2109C72.2622 47.0352 70.2471 47.0352 69.0076 48.2109C67.7681 49.3866 67.7681 51.2979 69.0076 52.4735L73.9043 57.118V57.118Z",
    fill: "#E7E7E7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogoutMenu);
export default __webpack_public_path__ + "static/media/icon_logout_menu.ab50a13730ca8ae1cf35d54a15a3f69c.svg";
export { ForwardRef as ReactComponent };